// extracted by mini-css-extract-plugin
module.exports = {"row":"WatcherLinkCard_row__wJFuv","value":"WatcherLinkCard_value__L9Y4e","link":"WatcherLinkCard_link__261Pq"};